package com.gsb.vyapar.bhagya.presentation.business.view

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Card
import androidx.compose.material.ExperimentalMaterialApi
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.domain.Business
import com.gsb.vyapar.bhagya.domain.getAddress
import com.gsb.vyapar.bhagya.domain.getCategoryId
import com.gsb.vyapar.bhagya.domain.getDescription
import com.gsb.vyapar.bhagya.domain.getEmail
import com.gsb.vyapar.bhagya.domain.getLatitude
import com.gsb.vyapar.bhagya.domain.getLogo
import com.gsb.vyapar.bhagya.domain.getLongitude
import com.gsb.vyapar.bhagya.domain.getDisplayName
import com.gsb.vyapar.bhagya.domain.getId
import com.gsb.vyapar.bhagya.domain.getName
import com.gsb.vyapar.bhagya.domain.getPhone1
import com.gsb.vyapar.bhagya.domain.getPhone2
import com.gsb.vyapar.bhagya.domain.getSubCategoryIds
import com.gsb.vyapar.bhagya.domain.isBusinessDeleted
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.launchDefault
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.business.uistate.getBusinessUiState
import com.gsb.vyapar.bhagya.presentation.business.uistate.isFavoriteBusiness
import com.gsb.vyapar.bhagya.presentation.business.util.getCategoryName
import com.gsb.vyapar.bhagya.presentation.business.util.getSubCategories
import com.gsb.vyapar.bhagya.presentation.common.image.BusinessCardPlaceHolder
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.image.PlaceHolder
import com.gsb.vyapar.bhagya.presentation.common.image.SmoothImage
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularBBStart
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularS
import com.gsb.vyapar.bhagya.presentation.common.text.Text18SemiBold
import com.gsb.vyapar.bhagya.share
import com.gsb.vyapar.bhagya.theme.*
import com.gsb.vyapar.bhagya.util.PLACEHOLDERIMG
import com.gsb.vyapar.bhagya.util.getMapUrl
import com.gsb.vyapar.bhagya.util.getWebApp
import com.gsb.vyapar.bhagya.util.value

@OptIn(ExperimentalMaterialApi::class)
@Composable
fun BusinessCardFull(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit, businessOld: Business, onClick: () -> Unit) {
    val uriHandler = LocalUriHandler.current
    val business = getBusinessUiState().isBusinessFetched.value[businessOld.getId()] ?: businessOld
    var name by remember { mutableStateOf("") }
    var categoryDetails by remember { mutableStateOf("") }
    var address by remember { mutableStateOf("") }
    var image by remember { mutableStateOf(uiState.getImage(PLACEHOLDERIMG.value())) }
    Card(
        modifier = Modifier.fillMaxWidth(),
        shape = RoundedCornerShape(8.dp),
        backgroundColor = offwhite,
        onClick = { onClick() },
    ) {
        Column(modifier = Modifier.fillMaxWidth().padding(16.dp)) {
            Row() {
                SmoothImage(image, width = 100.dp, height = 100.dp)
                Spacer(Modifier.width(8.dp))
                Column {
                    Text18SemiBold(text = name, color = black)
                    Spacer(Modifier.height(8.dp))
                    Text14RegularBBStart(text = categoryDetails, color = black)
                    Spacer(Modifier.height(8.dp))
                    Text14RegularS(text = address, black)
                }
            }
            Spacer(Modifier.height(16.dp))
            LazyRow(Modifier.fillMaxWidth().height(30.dp), horizontalArrangement = Arrangement.SpaceEvenly, verticalAlignment = Alignment.CenterVertically) {
                item { BusinessCardPlaceHolder(if (uiState.businessUiState.favorites.value.isFavoriteBusiness(business)) fav_on else fav_off, modifier = Modifier.clickable { if (!(getBusinessUiState().isBusinessFetched.value[business.getId()] ?: business).isBusinessDeleted()) uiState.businessUiState.toggleFavoriteBusiness(business) }) }
                item { BusinessCardPlaceHolder(call, modifier = Modifier.clickable { if (!business.isBusinessDeleted()) uriHandler.openUri("tel:${(getBusinessUiState().isBusinessFetched.value[business.getId()] ?: business).getPhone1()}") }) }
                if (business.getPhone2().isNotEmpty()) item { BusinessCardPlaceHolder(call, modifier = Modifier.clickable { if (!business.isBusinessDeleted()) uriHandler.openUri("tel:${(getBusinessUiState().isBusinessFetched.value[business.getId()] ?: business).getPhone2()}") }) }
                item { BusinessCardPlaceHolder(mail, modifier = Modifier.clickable { if (!business.isBusinessDeleted()) uriHandler.openUri("mailto:${(getBusinessUiState().isBusinessFetched.value[business.getId()] ?: business).getEmail()}") }) }
                item { BusinessCardPlaceHolder(whatsapp, modifier = Modifier.clickable { if (!business.isBusinessDeleted()) uriHandler.openUri("https://wa.me/+91${(getBusinessUiState().isBusinessFetched.value[business.getId()] ?: business).getPhone1()}") }) }
                if (business.getPhone2().isNotEmpty()) item { BusinessCardPlaceHolder(whatsapp, modifier = Modifier.clickable { if (!business.isBusinessDeleted()) uriHandler.openUri("https://wa.me/+91${(getBusinessUiState().isBusinessFetched.value[business.getId()] ?: business).getPhone2()}") }) }
                item { BusinessCardPlaceHolder(direction, modifier = Modifier.clickable { if (!(getBusinessUiState().isBusinessFetched.value[business.getId()] ?: business).isBusinessDeleted()) uriHandler.openUri(
                    getMapUrl(business.getLatitude(), business.getLongitude())
                ) }) }
                item { BusinessCardPlaceHolder(share, modifier = Modifier.clickable { if (!(getBusinessUiState().isBusinessFetched.value[business.getId()] ?: business).isBusinessDeleted()) share("\n" + business.getName() + "\n\nBusiness Link : ${getWebApp()}?business=${business.getId()}" + "\n\n" + business.getDescription()+ "\n\n") }) }
            }
        }
    }
    LaunchedEffect(Unit) {
        launchDefault {
            name = business.getDisplayName()
            categoryDetails = getCategoryName(business.getCategoryId()) + " " + getSubCategories(business.getSubCategoryIds()).toString()
            address = business.getAddress()
            uiState.getImageCallback(business.getLogo()) {
                image = it
            }
        }
    }
}